import { useEffect, useState } from "react";
import { Clock, Building2 } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { PageTitle, PageSubtitle, Loader, EmptyState, Card } from "@/components/common";

function fmt(m) {
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h} h ${r} min` : `${h} h`;
}

export default function DepotStatsPage() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiFetch("/depot-stats").then(setStats).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-3">
      <PageTitle>Tempi attesa depositi</PageTitle>
      <PageSubtitle>Tempo medio tra arrivo e inizio operazioni, calcolato solo sulle soste registrate nei viaggi reali.</PageSubtitle>
      {loading ? (
        <Loader />
      ) : stats.length === 0 ? (
        <EmptyState icon={Clock} title="Nessun dato ancora" text="I tempi medi appariranno qui quando vettori e autisti registreranno le soste sui viaggi." />
      ) : (
        stats.map((s) => (
          <Card key={s.depot} data-testid={`depot-stat-${s.depot}`}>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary">
                <Building2 className="h-5 w-5 text-primary" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate font-extrabold text-foreground">{s.depot}</p>
                <p className="text-xs text-muted-foreground">
                  {(s.soste ?? s.samples)} {(s.soste ?? s.samples) === 1 ? "sosta registrata" : "soste registrate"}
                </p>
              </div>
            </div>
            <div className="mt-3 flex gap-2">
              <Metric value={fmt(s.avg_wait_minutes)} label="attesa media" />
              {s.avg_operation_minutes != null ? <Metric value={fmt(s.avg_operation_minutes)} label="operazioni" /> : null}
              {s.avg_total_minutes != null ? <Metric value={fmt(s.avg_total_minutes)} label="permanenza" /> : null}
            </div>
          </Card>
        ))
      )}
    </div>
  );
}

function Metric({ value, label }) {
  return (
    <div className="flex-1 rounded-xl bg-secondary px-3 py-2 text-center">
      <p className="text-[15px] font-extrabold text-secondary-foreground">{value}</p>
      <p className="text-[10px] font-bold text-secondary-foreground/80">{label}</p>
    </div>
  );
}
